import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IAssignUomForm } from 'bom/types';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { FormProvider, useNotificationContext } from 'core/states';

import { assignUomSchema } from './schema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: IAssignUomForm) => void;
  options: string[];
}

export const AssignUom = ({ isOpen, onClose, onSubmit, options }: IProps) => {
  const { t } = useTranslation();
  const { clearNotification } = useNotificationContext();

  const handleOnSubmit = (reset: UseFormReset<IAssignUomForm>) => (data: IAssignUomForm) => {
    onSubmit(data);
    handleOnClose(reset);
  };

  const handleOnClose = (reset: UseFormReset<IAssignUomForm>) => {
    clearNotification();
    reset();
    onClose();
  };

  const uomOptions = options.map((option) => ({ value: option, label: option }));

  return (
    <FormProvider schema={assignUomSchema()}>
      <Form
        title={t('buttonLabelChangeSelectedTo')}
        isOpen={isOpen}
        onClose={handleOnClose}
        onSubmit={handleOnSubmit}
        submitBtnLabel={t('buttonLabelChangeSelectedTo')}
      >
        <FormField
          name="uom"
          type={InputType.SELECT}
          inputProps={{
            label: t('changeUomTo'),
            placeholder: t('placeholderChooseUom'),
            options: uomOptions,
            required: true,
          }}
        />
      </Form>
    </FormProvider>
  );
};
